import { SearchViewModel } from '@api/v3';
import CustomIcon from '@components/utils/CustomIcon';
import { FlexibleDiv } from '@components/formStyles';
import {
  ItemText,
  ItemTextWrapper,
  SearchBarList,
  SearchBarListItem,
} from '@components/ui/search/SearchResultListStyle';
import { getLocationIcon } from '@components/ui/search/SearchLocation/utils/getLocationIcon';
import { SearchResultError } from '@components/ui/search/SearchBarInput/SearchBarSearchInput/SearchBarSearchInputStyle';

interface DestinationSearchResultListProps {
  onSelect: (airport: SearchViewModel) => void;
  data: Array<SearchViewModel>;
  isError: boolean;
  isTour?: boolean;
}

const DestinationSearchResultList = ({
  onSelect,
  data = [],
  isError = false,
  isTour,
}: DestinationSearchResultListProps) => {
  if (isError) {
    return (
      <SearchResultError>
        Aradığınız kriterlere uygun sonuç bulunamadı.
      </SearchResultError>
    );
  }

  if (data.length === 0) return null;

  return (
    <SearchBarList
      isTour={isTour}
      dataSource={data}
      renderItem={(item: SearchViewModel) => (
        <SearchBarListItem onClick={() => onSelect(item)}>
          <CustomIcon
            width={24}
            height={24}
            fontSize={24}
            paletteColor='brownishGrey'
            icon={getLocationIcon(item?.type ?? '')}
          />
          <FlexibleDiv right={17} />
          <ItemTextWrapper>
            <ItemText>{item.text}</ItemText>
          </ItemTextWrapper>
        </SearchBarListItem>
      )}
    />
  );
};

export default DestinationSearchResultList;
